module.exports = __webpack_public_path__ + "static/img/award4_a.68460c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award4_a.png
// module id = imk0
// module chunks = 7